export default [
  {
    path: '/smile',
    component: () => import('@/views/smile/SmileMain.vue'),
    meta: {
      isHeader: false,
      isBack: false,
      isNav: true,
      titleName: ''
    }
  },

  // 행사장
  {
    path: '/smile/event/menu',
    component: () => import('@/views/smile/event/SmileMenu.vue'),
    meta: {
      isHeader: false,
      isBack: true,
      isHome: true,
      isNav: true,
      titleName: '행사장 만들기 선택'
    }
  },
  {
    path: '/smile/event/search',
    component: () => import('@/views/smile/event/SmileSearch.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: true,
      isHome: true,
      titleName: '행사장 검색'
    }
  },
  {
    path: '/smile/event/list',
    component: () => import('@/views/more/smile/SmileList.vue'),
    meta: {
      isHeader: false,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: ''
    }
  },

  {
    path: '/smile/event/info/:smileNo',
    component: () => import('@/views/smile/event/SmileDetail.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: ''
    }
  },
  {
    path: '/smile/event/info/hall/:smileNo',
    component: () => import('@/views/smile/event/SmileHall.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '',
      isSmileKakaoShare: true,
      isSmileShare: true
    }
  },
  {
    path: '/smile/event/info/chat/:smileNo',
    component: () => import('@/views/smile/event/SmileChat.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '축하하기',
      isSmileShare: true,
      isSmileKakaoShare: true
    }
  },
  {
    path: '/smile/event/info/gallery/:smileNo',
    component: () => import('@/views/smile/event/SmileGallery.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '갤러리'
    }
  },
  {
    path: '/smile/event/info/place/:smileNo',
    component: () => import('@/views/smile/event/place/SmilePlace.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '현장 이모저모'
    }
  },
  {
    path: '/smile/event/place/form/:smileNo',
    component: () => import('@/views/smile/event/place/SmilePlaceForm.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '현장사진 공유하기 '
    }
  },

  // 등록폼
  {
    path: '/smile/event/form/info',
    component: () => import('@/views/smile/event/form/Step1_Form.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 행사장 만들기'
    }
  },
  {
    path: '/smile/event/form/alert',
    component: () => import('@/views/smile/event/form/Step2_AlertForm.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 행사장 만들기'
    }
  },
  {
    path: '/smile/event/form/background',
    component: () => import('@/views/smile/event/form/Step3_BackgroundForm.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 행사장 만들기'
    }
  },

  {
    path: '/smile/event/form/info/invitation/:invitationNo',
    component: () => import('@/views/smile/event/form/edit/Step1_FormByInvitation.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 행사장 등록하기'
    }
  },

  // 수정폼
  {
    path: '/smile/event/form/info/:smileNo',
    component: () => import('@/views/smile/event/form/edit/Step1_EditForm.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 행사장 수정하기'
    }
  },
  {
    path: '/smile/event/form/alert/:smileNo',
    component: () => import('@/views/smile/event/form/edit/Step2_EditAlertForm.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 행사장 수정하기'
    }
  },
  {
    path: '/smile/event/form/background/preview',
    component: () => import('@/views/smile/event/form/SmilePreView.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '미리보기'
    }
  },

  {
    path: '/smile/event/form/background/:smileNo',
    component: () => import('@/views/smile/event/form/edit/Step3_EditBackgroundForm.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isBack: true,
      isNav: false,
      titleName: '온라인 행사장 수정하기'
    }
  },

  // 초대장 (소중한날 함께하기)
  {
    path: '/smile/invitation/menu',
    component: () => import('@/views/smile/invitation/InvitationMenu.vue'),
    meta: {
      isHeader: false,
      isBack: true,
      isHome: true,
      isNav: true,
      titleName: '초대장 만들기 선택'
    }
  },

  {
    path: '/smile/invitation/form/info',
    component: () => import('@/views/smile/invitation/form/InvitationForm.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '초대장 만들기'
    }
  },

  {
    path: '/smile/invitation/form/share/:smileNo',
    component: () => import('@/views/smile/invitation/form/InvitationShareForm.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '초대장 만들기'
    }
  },

  {
    path: '/smile/invitation/form/edit/:invitationNo',
    component: () => import('@/views/smile/invitation/form/InvitationEditForm.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isNav: false,
      isHome: true,
      titleName: '온라인 소중한날 수정하기'
    }
  },
  {
    path: '/smile/invitation/list',
    component: () => import('@/views/smile/invitation/InvitationList.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '온라인 초대장 관리'
    }
  },
  {
    path: '/smile/invitation/info/:invitationNo',
    component: () => import('@/views/smile/invitation/Invitation.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '',
      isInvitationShare: true,
      isInvitationKakaoShare: true
    }
  },
  {
    path: '/smile/return/form/:smileNo/:category',
    component: () => import('@/views/smile/return/Form.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isNav: false,
      titleName: '답례장'
    }
  }
];
